import { render } from "./BlogPostView.vue?vue&type=template&id=de6fc8d0"
import script from "./BlogPostView.vue?vue&type=script&lang=js"
export * from "./BlogPostView.vue?vue&type=script&lang=js"
script.render = render

export default script